export const isEqlFieldCohorts = (field: string) => {
  return field === 'metadata.common.cohorts';
};
